import { render } from "./AccommodationNearbyCarousel.vue?vue&type=template&id=2c786b98&scoped=true&ts=true"
import script from "./AccommodationNearbyCarousel.vue?vue&type=script&lang=ts"
export * from "./AccommodationNearbyCarousel.vue?vue&type=script&lang=ts"

import "./AccommodationNearbyCarousel.vue?vue&type=style&index=0&id=2c786b98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c786b98"]])

export default __exports__